// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 604) return "/dist/js/header.js";
	if (chunkId === 825) return "/dist/js/menu-mobile.js";
	if (chunkId === 149) return "/dist/js/carousel-team.js";
	if (chunkId === 494) return "/dist/js/carousel-testimonials.js";
	if (chunkId === 27) return "/dist/js/gallery.js";
	if (chunkId === 100) return "/dist/js/gallery-grid.js";
	if (chunkId === 753) return "/dist/js/fancybox-image.js";
	if (chunkId === 311) return "/dist/js/openstreet-map.js";
	if (chunkId === 864) return "/dist/js/slider.js";
	if (chunkId === 251) return "/dist/js/carousel-partners.js";
	// return url for filenames based on template
	return undefined;
};